import { ProductRepaymentTypes, ProductType } from 'domain/Product';
import { State } from '../types';

export type Products = State['products'];

export type Product = {
  id: number;
  product: string;
  code: string;
  type: ProductType;
  tier: string;
  fullname: string;
  availableRepaymentTypes: ProductRepaymentTypes[];
};

export enum ACTION_TYPES {
  STORE_PRODUCTS_SUCCESS = 'CM/CASE/PRODUCTS/STORE/SUCCESS',
}
